<nb-card accent="success">
  <nb-card-header>
    <div class="d-flex">
      <div class="flex-grow-1 d-flex align-items-center justify-content-center">
        <nb-icon icon="play-circle-outline" *ngIf="action === 'activate'"></nb-icon>
        <nb-icon icon="stop-circle-outline" *ngIf="action === 'deactivate'"></nb-icon>
        <div class="ml-2" *ngIf="action === 'activate'" i18n>Activating Insight: {{ insight.id }}</div>
        <div class="ml-2" *ngIf="action === 'deactivate'" i18n>Deactivating Insight: {{ insight.id }}</div>
      </div>
      <button nbButton class="ml-3" (click)="close()">
        <nb-icon icon="close-outline"></nb-icon>
      </button>
    </div>
  </nb-card-header>
  <nb-card-body>
    <div class="col" *ngIf="action === 'activate'">
      <div class="field-label" i18n>Start Time<span style="color: red">*</span></div>
      <input
        id="start"
        nbInput
        [(ngModel)]="startDate"
        required
        [owlDateTime]="startPicker"
        [min]="minStartDate"
        [owlDateTimeTrigger]="startPicker"
        (ngModelChange)="changeEvent()"
        placeholder="Select Start Time"
        i18n-placeholder
      />
      <owl-date-time #startPicker></owl-date-time>
      <div class="field-label mt-3" i18n>End Time<span style="color: red">*</span></div>
      <input
        id="end"
        nbInput
        [(ngModel)]="endDate"
        required
        [owlDateTime]="endPicker"
        [min]="minEndDate"
        [owlDateTimeTrigger]="endPicker"
        (ngModelChange)="changeEvent()"
        placeholder="Select End Time"
        i18n-placeholder
      />
      <owl-date-time #endPicker></owl-date-time>
      <div class="field-label mt-3" i18n>Schedule<span style="color: red">*</span></div>
      <nb-select
        id="schedule_seconds"
        name="schedule_seconds"
        class="custom small"
        placeholder="Select Schedule"
        i18n-placeholder
        [(ngModel)]="insight.schedule_seconds"
        style="width: 100%"
      >
        <nb-option *ngFor="let frequency of FREQUENCIES" [value]="frequency.value">{{ frequency.label }} </nb-option>
      </nb-select>
      <div class="mt-3" i18n>Are you sure you want to activate this insight?</div>
    </div>
    <div class="col" *ngIf="action === 'deactivate'">
      <div i18n>Are you sure you want to deactivate this insight?</div>
    </div>
  </nb-card-body>
  <nb-card-footer>
    <div class="d-flex justify-content-end">
      <button nbButton (click)="close()" i18n>No</button>
      <button
        *ngIf="action === 'activate'"
        nbButton
        class="ml-3"
        status="success"
        (click)="activate()"
        [disabled]="!insight.start_date && !insight.end_date && !insight.schedule_seconds"
        nbTooltip="Clicking Yes will start the Insight as per the schedule."
        i18n-nbTooltip
        i18n
      >
        Yes
      </button>
      <button
        *ngIf="action === 'deactivate'"
        nbButton
        class="ml-3"
        status="danger"
        (click)="deactivate()"
        nbTooltip="Clicking Yes will deactivate the Insight immediately."
        i18n-nbTooltip
        i18n
      >
        Yes
      </button>
    </div>
  </nb-card-footer>
</nb-card>
